























import { InfoBlocksEnum } from "@service/types/InfoBlocksEnum";
import { SegmentDataItem } from "@share/common/segment/SegmentData";
import { Vue, Component, Prop } from "vue-property-decorator";
import { SettingsViewPart } from "../../types/SettingsViewPart";

import SegmentControl from "@share/common/segment/Segment.vue";
import LogoutButton from "../buttons/LogoutButton.vue";
import DeviceTestButton from "../buttons/DeviceTestButton.vue";

@Component({ components: { SegmentControl, LogoutButton, DeviceTestButton } })

export default class SettingsHeader extends Vue {
    @Prop() segmentData: SegmentDataItem[];
    @Prop({ default: true }) needShowButtons: boolean;

    InfoBlocksEnum = InfoBlocksEnum;

    onViewPartChange(value: SettingsViewPart) {
        this.$emit('viewPartChange', value)
    }

    get deviceTestTooltipData() {
        return this.$t('web-conferences.deviceTest');
    }

    get logoutTooltipData() {
        return this.$t('common.logout');
    }
}

